import { render, staticRenderFns } from "./performanceLevel.vue?vue&type=template&id=1b1f8506&scoped=true&"
import script from "./performanceLevel.vue?vue&type=script&lang=js&"
export * from "./performanceLevel.vue?vue&type=script&lang=js&"
import style0 from "./performanceLevel.vue?vue&type=style&index=0&id=1b1f8506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f8506",
  null
  
)

component.options.__file = "performanceLevel.vue"
export default component.exports